// legacy common modules
import common from "./common.en";
import layouts from "./layouts.en";
import oneonone from "./oneonone.en";
import disc from "./disc.en";

// new separated modules
import components from "../components/lang.en";

export default {
	// separating these for maintenance convenience, but they should
	// be grouped under the "common" namespace together
	common: {
		...common,
		...layouts,
		...oneonone,
		...disc,
	},
	"common-ui": {
		components,
	},
};
